import { PatchCollection } from "@reduxjs/toolkit/dist/query/core/buildThunks"
import { NotificationInternalPayload } from "../../models/notification"
import { saveNotificationError, saveNotificationFakeError } from "../../store/notifications/thunks"
import { apiCallExceptionToSystemError } from "../../utility/common/apiCallExceptionToSystemError"
import { Dispatch } from "../../utility/common/storeHelper"

export const handleQueryApiError = (
    dispatch: Dispatch,
    errorMessage: string,
    e: unknown,
    patchResults?: (PatchCollection | undefined)[]
) => {
    const error = apiCallExceptionToSystemError(errorMessage, e)
    saveNotificationError(dispatch, error)

    if (patchResults) {
        for (const patchResult of patchResults) {
            if (patchResult) patchResult.undo()
        }
    }
}

export const handleQueryApiFakeError = (
    dispatch: Dispatch,
    message: NotificationInternalPayload,
    patchResults?: (PatchCollection | undefined)[]
) => {
    saveNotificationFakeError(dispatch, message)

    if (patchResults) {
        for (const patchResult of patchResults) {
            if (patchResult) patchResult.undo()
        }
    }
}
